import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './modules/auth/components/login/login.component';
import { DeGuard } from './modules/core/services/de.guard';
import { RouteGaurdService as RouteGaurd, RouteGaurdService } from './modules/core/services/route-gaurd/route-gaurd.service';
import { EhsDataComponent } from './modules/admin/components/ehs-data/ehs-data.component';
import { DefaultLayoutComponent } from './containers';
import { ApprovalsPoComponent } from './modules/pr-buyer/components/approvals-po/approvals-po.component';
import { UnregisteredComponent } from './modules/unregistered/unregistered.component';
import { UnregisteredVendorNegotiationComponent } from './unregistered-vendor-negotiation/unregistered-vendor-negotiation.component';
import { BulkUploadHistoryComponent } from './modules/pr-initiator/components/bulk-upload-history/bulk-upload-history.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'login'
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate : [ DeGuard ]
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    children: [{
      path: 'ehs/home',
      component: EhsDataComponent,
      canLoad: [RouteGaurdService]
    },{
      path:'po-history/:prId',
      component: ApprovalsPoComponent,
      canActivate:[RouteGaurd]
    },
    {
      path: 'bulkPRhistory',
      component: BulkUploadHistoryComponent,
      canActivate: [ RouteGaurd ]
    }
  ]

  },
  {
    path: 'dashboard',
    loadChildren: () => import('./modules/dashboard/dashboard.module').then(m => m.DashboardModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'login-module',
    loadChildren: () => import('./modules/auth/auth.module').then(m => m.AuthModule),
  },
  {
    path: 'buyer',
    loadChildren: () => import('./modules/pr-buyer/pr-buyer.module').then(m => m.PrBuyerModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'supplier',
    loadChildren: () => import('./modules/supplier/supplier.module').then(m => m.SupplierModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'po-buyer',
    loadChildren: () => import('./modules/po-buyer/po-buyer.module').then(m => m.PoBuyerModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'pr-initiator',
    loadChildren: () => import('./modules/pr-initiator/pr-initiator.module').then(m => m.PrInitiatorModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'upload',
    loadChildren: () => import('./modules/upload/upload.module').then(m => m.UploadModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'userManagement',
    loadChildren: () => import('./modules/user-management/user-managemet.module').then(m => m.UserManagemetModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'qes-approver',
    loadChildren: () => import('./modules/qes-approver/qes-approver.module').then(m => m.QESApproverModule),
    canLoad : [ RouteGaurdService ]
  },
  {
    path: 'admin',
    loadChildren: () => import('./modules/admin/admin.module').then(m => m.AdminModule),
    canLoad : [ RouteGaurdService ]
  },
  { 
    path: 'unregistered', 
    component: UnregisteredComponent
  },
  {
    path:'unregitered-vendor-negotiation',
    component: UnregisteredVendorNegotiationComponent
  }
];


@NgModule({
  // imports: [RouterModule.forRoot(routes, { useHash: true }), ],
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
